import { gql } from '@apollo/client';

export const LIVE_SESSIONS_QUERY = gql`
  query LiveSessions(
    $organisationId: Uuid!,
    $limit: Int!,
    $offset: Int!,
    $where: LiveSessionsBoolExp
  ) {
    liveSessions(
      where: $where,
      limit: $limit,
      offset: $offset,
      order_by: {startTime: Asc}
    ) {
      id
      title
      subtitle
      description
      startTime
      duration
      meetingId
      providerConfigs
      provider
      type
      status
      createdAt
      updatedAt
      createdBy
      organisationId
      cardImageUrl
      liveSessionProvider {
        name
      }
      liveSessionCourses {
        course {
          id
          openedxCourseId
          _CourseOverviewsCourseoverview {
            courseImageUrl
            displayName
            endDate
            startDate
          }
        }
      }
    }
    liveSessionsAggregate(agg: { where: $where }) {
      agg_count
    }
  }
`;

export const GET_LIVE_SESSION_BY_ID = gql`
  query GetLiveSession($id: Uuid!, $organisationId: Uuid!) {
    liveSessions(
      where: {
        id: { _eq: $id },
        organisationId: { _eq: $organisationId }
      }
    ) {
      id
      title
      subtitle
      description
      startTime
      duration
      meetingId
      providerConfigs
      provider
      type
      status
      createdAt
      updatedAt
      createdBy
      organisationId
      cardImageUrl
      liveSessionProvider {
        name
      }
      liveSessionCourses {
        course {
          id
          openedxCourseId
          _CourseOverviewsCourseoverview {
            courseImageUrl
            displayName
            endDate
            startDate
          }
        }
      }
    }
  }
`;

export const GET_LIVE_VIDEO_RECORDING = gql`
  query GetLiveVideoRecording($liveSessionId: Uuid = "") {
    liveSessionsRecordings(where: { liveSessionId: { _eq: $liveSessionId } }) {
      liveSessionId
      videoLibraryId
      id
      videoLibrary {
        thumbnail
        mp4Link
        metadata
        title
        id
        hlsLink
        createdAt
      }
    }
  }
`;
